/**
 * Created by orenm on 12/10/2014.
 */
define(function (require) {
    "use strict";
    var BaseModel = require("models/BaseModel");
    var ApiResources = require("assets/data/apiResources.json");
    // todo remove



    var SnippetModel = {};

    LE.module("LEConnection", function (LEConnection, LE, Backbone, Marionette, $, _) {
        SnippetModel = BaseModel.extend({
            name: "SnippetModel",
            defaults: {
                priority: 0,
                activity: [],
                isRead: false
            },
            idAttribute: "cb_key",

            initialize: function (options, fetchOptions) {
                options = options || {};

                if(fetchOptions && fetchOptions.isPrioritizable) {
                    options.currentActivities = options.currentActivities || [];
                    this.calculatePriority(options.currentActivities);
                }

                if(options && options.slug && options.lang) {

                    this._initializeResource(options);
                }
            },

            _initializeResource: function (options) {
                var slug = options.slug;
                var lang = options.lang;
                var isAuthenticated = LE.sessionManager.isAuthenticated();


                this.resource= _.clone(ApiResources.ConnectionPanel.Article);
                this.originalUrl = isAuthenticated ? this.resource.securedUrl : this.resource.url;

                // TODO validate
                this.resource.url = this.originalUrl;
                this.resource.url = this.resource.url.replace("{slug}", slug);
                this.resource.url = this.resource.url.replace("{lang}", lang);

            },

            calculatePriority: function (currentActivities) {
                var modelActivities = this.get("activity");
                var priority;

                priority = (_.intersection(currentActivities, modelActivities).length);
                this.set("priority", priority);
            }

        });
    });
    return SnippetModel;
});
